import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';
import type { DashboardPageProps } from '../../../lib/dashboard-page';
import { AuthLayout } from '../components/auth-layout';
import { AuthLogo } from '../components/auth-logo';
import { ChecklistItem } from '../components/checklist-item';
import { InviteRegisterForm } from '../components/invite-register-form';
import { ReturnToLoginLink } from '../components/return-to-login-link';

const PAGE = 'features:auth.pages.register_invite_page' satisfies I18nPrefix;

type RegisterInvitePageProps = {
  email: string;
};

export function RegisterInvitePage({
  handlers,
  pageProps = { email: '' },
}: DashboardPageProps<RegisterInvitePageProps>) {
  const { navigationHandler } = handlers;

  return (
    <AuthLayout>
      <div className="sm:mx-auto sm:w-full sm:max-w-lg lg:max-w-5xl">
        <AuthLogo className="h-9 w-auto lg:hidden" />
        <div className="block lg:flex lg:justify-between">
          <div className="mt-20 hidden lg:block">
            <AuthLogo className="mb-12 hidden h-9 w-auto lg:block" />
            <dl className="space-y-10 sm:w-3/4 sm:max-w-lg md:grid md:grid-cols-1 md:gap-x-8 md:gap-y-10 md:space-y-0">
              <ChecklistItem
                title={t(`${PAGE}.checklist.enable.title`)}
                description={t(`${PAGE}.checklist.enable.description`)}
              />
              <ChecklistItem
                title={t(`${PAGE}.checklist.onboarding.title`)}
                description={t(`${PAGE}.checklist.onboarding.description`)}
              />
              <ChecklistItem
                title={t(`${PAGE}.checklist.experience.title`)}
                description={t(`${PAGE}.checklist.experience.description`)}
              />
            </dl>
          </div>
          <div className="mx-auto max-w-lg lg:w-2/4">
            <div className="mt-8 rounded-lg border border-spark-border-subtle bg-spark-surface p-8 shadow-xl sm:p-14">
              <div>
                <h2 className="mb-4 font-bold text-spark-text-primary text-xl sm:text-2xl">
                  {t(`${PAGE}.heading`)}
                </h2>
                <p className="max-w mt-2 text-sm text-spark-text-secondary">
                  {t(`${PAGE}.description`)}
                </p>
              </div>

              <div className="mt-6">
                <InviteRegisterForm handlers={handlers} email={pageProps.email} />
              </div>
            </div>
            <ReturnToLoginLink
              navigationHandler={navigationHandler}
              className="max-w pt-8 text-sm text-spark-text-secondary"
            />
          </div>
        </div>
      </div>
    </AuthLayout>
  );
}
